export const STATUS_ACTIVE = 'ACTIVE'
export const STATUS_INACTIVE = 'INACTIVE'
export const STATUS_PENDING = 'PENDING'